import { useCallback, useEffect, useRef } from 'react'
import useAppStore from './useAppStore'

/**
 * Dev-only: time from a raster layer's URL changing to MapLibre tiles finishing
 * (map `idle` event).
 */
export function useRasterLoadTiming(label: string, url: string | undefined) {
  const mapRef = useAppStore((s) => s.mapRef)
  const startedAt = useRef<number | null>(null)

  const markDone = useCallback(() => {
    if (startedAt.current === null) return
    const elapsed = Math.round(performance.now() - startedAt.current)
    startedAt.current = null
    console.info(`[${label}] idle after ${elapsed} ms — ${url}`)
  }, [label, url])

  useEffect(() => {
    if (!import.meta.env.DEV || !url) return
    startedAt.current = performance.now()

    if (!mapRef) return
    const map = mapRef.getMap()

    const onIdle = () => markDone()
    map.once('idle', onIdle)
    return () => {
      map.off('idle', onIdle)
    }
  }, [label, url, mapRef, markDone])
}
